document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mount-countdown .card').forEach(card => {
    card.style.cursor = 'pointer';
    card.addEventListener('click', (e) => {
      if (e.target.closest('a, button')) return;
      window.location.href = '/pages/aktion';   // ← THIS is where the link is set
    });
  });
});